import React, { type FC, use, useMemo } from "react";
import { FileUploaderContext } from "../../context/FileUploaderContext";
import { UploadFileItem } from "./UploadFileItem";
import { UploadFileStatus } from "@dms/types";

export const UploadFileList: FC = () => {
    const { allFilesInfo } = use(FileUploaderContext);

    const uploadFiles = useMemo(() => {
        return allFilesInfo.filter((el) =>
            [
                UploadFileStatus.PROGRESS,
                UploadFileStatus.READY_FOR_UPLOAD,
                UploadFileStatus.DONE,
                UploadFileStatus.ERROR,
            ].includes(el.status),
        );
    }, [allFilesInfo]);

    if (!uploadFiles.length) {
        return null;
    }

    return (
        <div className="w-full gap-1">
            {uploadFiles.map((file) => {
                return <UploadFileItem key={file.hash} file={file.file} status={file.status} error={file.error} />;
            })}
        </div>
    );
};
